module.exports = __webpack_public_path__ + "static/media/35_Schalla_webfinal.bae4cc1f.jpg";